// extracted by mini-css-extract-plugin
module.exports = {"cursor":"ReloveIconMessages_cursor__2lSop","root":"ReloveIconMessages_root__2DD-L"};